import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
import { MdBatteryFull } from "react-icons/md";
import { FaShop } from "react-icons/fa6";
import { RxDotsVertical } from "react-icons/rx";
import { CiFaceSmile } from "react-icons/ci";
import { FaPaperclip } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import { FaMicrophone } from "react-icons/fa";
import { IoMdPhonePortrait } from "react-icons/io";
import { FaRecycle } from "react-icons/fa";
import { MdSkipNext } from "react-icons/md";




import whatsappBgimage from '../images/whatsapp-mobile-image.png'
import setuptempalateImage from '../images/setuptempalteimage.png'
import whatsappnotch from '../images/Wp-notch-image.png'
import Whatsappicon from '../images/Whatsappicon.png'
import UtilityImage from '../images/Utilityimage.png'
import AuthenticationImage from '../images/AuthenticationImage.png'
import FlowtemplateImage from '../images/Flowtemplate.gif'
import LTOtemplateImage from '../images/LTOtemplate.png'
import CarouselTemplateimage from '../images/Carouseltemplate.gif'
import Utilityflowtemplate from '../images/UtilityFlowtemplate.gif'
import templatelibraryImage from '../images/templatelibrary.png'

function SetupYourTemplate() {

    const location = useLocation();
    const navigate = useNavigate();
    const [choosetemplate, setchoosetemplate] = useState('Default')
    const [activetab, setactivetab] = useState('marketing')
    const [changebg, setchangebg] = useState('marketing')

    const handletemplate = () => {
        navigate("/WAMessage/WATemplate/AddEditTemplate", { state: { choosetemplate, activetab } });
    };
    return (
        <>
            <div className='w-[100%] px-4'>
                <div className='flex gap-4 border-t-[1px] border-[#cfcdcd] pt-2'>

                    {/* Setup Template */}
                    <div
                        onClick={() => navigate('/WAMessage/WATemplate/SetupTemplate')}
                        className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
    ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate')
                                ? 'text-[#31b07b] border-[#31b07b]'
                                : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
                    >
                        <div
                            className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
      ${location.pathname.includes('/WAMessage/WATemplate/SetupTemplate')
                                    ? 'border-[#31b07b] bg-[#31b07b]'
                                    : 'border-[#9e9d9d]'}`}
                        >
                            {location.pathname.includes('/WAMessage/WATemplate/SetupTemplate') && (
                                <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>
                            )}
                        </div>
                        Set up template
                    </div>

                    {/* Edit Template */}
                    <div
                        onClick={() => navigate('/WAMessage/WATemplate/AddEditTemplate')}
                        className={`flex items-center gap-2 text-[12px] font-bold p-[5px] rounded-lg border-[1px] cursor-pointer
    ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate')
                                ? 'text-[#31b07b] border-[#31b07b]'
                                : 'text-[#9e9d9d] border-[#9e9d9d]'}`}
                    >
                        <div
                            className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
      ${location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate')
                                    ? 'border-[#31b07b] bg-[#31b07b]'
                                    : 'border-[#9e9d9d]'}`}
                        >
                            {location.pathname.includes('/WAMessage/WATemplate/AddEditTemplate') && (
                                <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'></div>
                            )}
                        </div>
                        Edit template
                    </div>

                </div>
                <div className='w-[100%] flex   flex-col md:flex-row mt-4 md:p-0 p-2 border-[1px] border-[#cfcdcd] rounded-lg '>
                    <div className='w-[100%] md:w-[70%] flex flex-col px-4 py-2'>
                        <h6 className='text-[16px] font-semibold'>Set up your Template</h6>
                        <p className='text-[12px] text-[#8f8e8e]'>Choose the category that best describes your message template. Then, select the type of message that you want to send. <span className='text-[#448c74] cursor-pointer'>Learn more about categories.</span>
                        </p>
                        <div className='flex mt-4 flex-wrap '>
                            <button
                                onClick={() => {
                                    setchoosetemplate('Default')
                                    setactivetab('marketing')
                                    setchangebg('marketing')
                                }}
                                className={`border-[1px] border-[#6c757d]  text-[#6c757d] font-semibold y-2 px-6 sm:px-10 md:px-14 text-[11px] sm:text-[12px] w-full sm:w-auto ${changebg === 'marketing' ? 'bg-[#f6f9fc] text-[#00816a]' : ''}`}>📢 Marketing</button>
                            <button onClick={() => {
                                setchoosetemplate('Default')
                                setactivetab('utility')
                                setchangebg('Utility')
                            }}
                                className={`border-[1px] border-[#6c757d] text-[#6c757d] font-semibold py-2 y-2 px-6 sm:px-10 md:px-14 text-[11px] sm:text-[12px] w-full sm:w-auto ${changebg === 'Utility' ? 'bg-[#f6f9fc] text-[#00816a]' : ''}`}>🔔 Utility</button>
                            <button onClick={() => {
                                setchoosetemplate('One-time-passcode')
                                setactivetab('Authentication')
                                setchangebg('Authentication')
                            }}
                                className={`border-[1px] border-[#6c757d] text-[#6c757d] font-semibold py-2 y-2 px-6 sm:px-10 md:px-14 text-[11px] sm:text-[12px] w-full sm:w-auto ${changebg === 'Authentication' ? 'bg-[#f6f9fc] text-[#00816a]' : ''}`}>🛡️ Authentication</button>
                        </div>
                        {activetab === 'marketing' ?
                            <div className='w-[100%] mt-4'>
                                <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'Default' ? 'bg-[#f6f9fc]' : ''}`}
                                    onClick={() => { setchoosetemplate('Default') }}
                                >
                                    <div
                                        className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'Default' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                    >{choosetemplate === 'Default' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                    </div> : ''

                                        }
                                    </div>
                                    <div>
                                        <h6 className='text-[14px] text-[#555454] font-semibold'>Default</h6>
                                        <p className='text-[12px] text-[#8f8e8e]'>Send messages with media and customised buttons to engage your customers.</p>
                                    </div>
                                </div>
                                <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'Flows' ? 'bg-[#f6f9fc]' : ''}`}
                                    onClick={() => { setchoosetemplate('Flows') }}
                                >
                                    <div
                                        className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'Flows' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                    >{choosetemplate === 'Flows' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                    </div> : ''

                                        }
                                    </div>
                                    <div>
                                        <h6 className='text-[14px] text-[#555454] font-semibold'>Flows</h6>
                                        <p className='text-[12px] text-[#8f8e8e]'>Send a form to capture customer interests, appointment requests or run surveys.</p>
                                    </div>
                                </div>
                                <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'LTO' ? 'bg-[#f6f9fc]' : ''}`}
                                    onClick={() => { setchoosetemplate('LTO') }}
                                >
                                    <div
                                        className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'LTO' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                    >{choosetemplate === 'LTO' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                    </div> : ''

                                        }
                                    </div>
                                    <div>
                                        <h6 className='text-[14px] text-[#555454] font-semibold'> Limited Time Offer (LTO)</h6>
                                        <p className='text-[12px] text-[#8f8e8e]'>Send urgent promotional messages that expire soon to boost engagement and conversions.</p>
                                    </div>
                                </div>
                                <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'Carousel' ? 'bg-[#f6f9fc]' : ''}`}
                                    onClick={() => { setchoosetemplate('Carousel') }}
                                >
                                    <div
                                        className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'Carousel' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                    >{choosetemplate === 'Carousel' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                    </div> : ''

                                        }
                                    </div>
                                    <div>
                                        <h6 className='text-[14px] text-[#555454] font-semibold'>Carousel</h6>
                                        <p className='text-[12px] text-[#8f8e8e]'>Send interactive carousel messages to showcase multiple products, services, or offers in a swipeable format.</p>
                                    </div>
                                </div>
                            </div> : activetab === 'utility' ?
                                <div className='w-[100%] mt-4'>
                                    <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'Default' ? 'bg-[#f6f9fc]' : ''}`}
                                        onClick={() => { setchoosetemplate('Default') }}
                                    >
                                        <div
                                            className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'Default' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                        >{choosetemplate === 'Default' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                        </div> : ''

                                            }
                                        </div>
                                        <div>
                                            <h6 className='text-[14px] text-[#555454] font-semibold'>Default</h6>
                                            <p className='text-[12px] text-[#8f8e8e]'>Send messages with media and customised buttons to engage your customers.</p>
                                        </div>
                                    </div>
                                    <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'Flows' ? 'bg-[#f6f9fc]' : ''}`}
                                        onClick={() => { setchoosetemplate('Flows') }}
                                    >
                                        <div
                                            className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'Flows' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                        >{choosetemplate === 'Flows' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                        </div> : ''

                                            }
                                        </div>
                                        <div>
                                            <h6 className='text-[14px] text-[#555454] font-semibold'>Flows</h6>
                                            <p className='text-[12px] text-[#8f8e8e]'>Send a form to capture customer interests, appointment requests or run surveys.</p>
                                        </div>
                                    </div>
                                    <div className='p-1 bg-[#f6f9fc] mt-4'>
                                        <div className='flex gap-2'>
                                            <img src={templatelibraryImage} alt=""
                                                className='w-20 h-20 object-contain'
                                            />
                                            <div>
                                                <h6 className='text-[16px] font-semibold'>Start With Pre-approved Templates</h6>
                                                <p className='text-[14px] text-[#8f8e8e]'>Save time by using pre-approved templates for your WhatsApp messages. These templates are designed to meet WhatsApp's guidelines and can be used immediately without the need for additional review.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='flex justify-end'>
                                            <Link to='/WAMessage/Templatelibrary/Index'>
                                                <button className='hover:bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] hover:text-[#fff] text-[#316bb0] font-bold p-2 gap-1 rounded-[5px]'>
                                                    Go to Templatet library <IoMdPhonePortrait /></button>
                                            </Link>
                                        </div>
                                    </div>
                                </div> : activetab === 'Authentication' ?
                                    <div className='w-[100%] mt-4'>
                                        <div className={`pl-6 py-3 flex items-center gap-1 ${choosetemplate === 'One-time-passcode' ? 'bg-[#f6f9fc]' : ''}`}
                                            onClick={() => { setchoosetemplate('One-time-passcode') }}
                                        >
                                            <div
                                                className={`w-[15px] h-[15px] border-[1px] rounded-full flex justify-center items-center
    ${choosetemplate === 'One-time-passcode' ? 'border-[#31b07b] bg-[#31b07b]' : 'border-[#9e9d9d]'}`}
                                            >{choosetemplate === 'One-time-passcode' ? <div className='w-[7px] h-[7px] bg-[#fff] rounded-full'>
                                            </div> : ''

                                                }
                                            </div>
                                            <div>
                                                <h6 className='text-[14px] text-[#555454] font-semibold'>One-time passcode</h6>
                                                <p className='text-[12px] text-[#8f8e8e]'>Send codes to verify a transaction or login.</p>
                                            </div>
                                        </div>
                                        <div className='p-1 bg-[#f6f9fc] mt-4'>
                                            <div className='flex gap-2'>
                                                <img src={templatelibraryImage} alt=""
                                                    className='w-20 h-20 object-contain'
                                                />
                                                <div>
                                                    <h6 className='text-[16px] font-semibold'>Start With Pre-approved Templates</h6>
                                                    <p className='text-[14px] text-[#8f8e8e]'>Save time by using pre-approved templates for your WhatsApp messages. These templates are designed to meet WhatsApp's guidelines and can be used immediately without the need for additional review.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='flex justify-end'>
                                                <Link to='/WAMessage/Templatelibrary/Index'>
                                                    <button className='hover:bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] hover:text-[#fff] text-[#316bb0] font-bold p-2 gap-1 rounded-[5px]'>
                                                        Go to Templatet library <IoMdPhonePortrait /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div> : null
                        }

                    </div>
                    <div className='w-[100%] md:w-[26%] p-4 flex flex-col justify-center sm:mt-[-15px] mt-[30px]  '>
                        <div className='scale-[0.80] origin-top'>
                            <div
                                className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center  '
                                style={{ backgroundImage: `url(${whatsappBgimage})` }}>
                                <div className='w-[266.5px] bg-contain bg-center bg-no-repeat bg-[#efeae2]  h-[570px] rounded-[40px]    '
                                    style={{
                                        backgroundImage: `url(${choosetemplate === 'Default' && activetab === 'marketing'
                                            ? setuptempalateImage
                                            : choosetemplate === 'Default' && activetab === 'utility'
                                                ? UtilityImage
                                                : activetab === 'Authentication' && choosetemplate === 'One-time-passcode' ? AuthenticationImage : choosetemplate === 'Flows' && activetab === 'marketing'  ? FlowtemplateImage : choosetemplate === 'LTO' ? LTOtemplateImage : choosetemplate === 'Carousel' ? CarouselTemplateimage : choosetemplate === 'Flows'  && activetab === 'utility' ? Utilityflowtemplate : null})`
                                    }}>
                                    <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px]  relative overflow-hidden  '>
                                        <div className='w-[100%] flex justify-between px-2'>
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                <span>12:00</span>
                                                <FaWhatsapp />
                                                <FaInstagram />
                                            </div>
                                            <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px] ' />
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                <FaWifi />
                                                <MdOutlineSignalCellularConnectedNoInternet4Bar />
                                                <MdBatteryFull />
                                            </div>
                                        </div>
                                        <div className='w-[100%] flex px-2 items-center  justify-between py-1 gap-1'>
                                            <div className='flex items-center text-[#fff] gap-1'>
                                                <FaArrowLeftLong className='text-[28px]' />
                                                <img src={Whatsappicon} alt="" className='w-10 h-10' />
                                                <div className='flex flex-col '>
                                                    <span className='text-[12px] text-wrap text-[#fff] font-bold'> Template Preview</span>
                                                    <span className='text-[10px] text-wrap text-[#fff]'>Business Account</span>
                                                </div>
                                            </div>
                                            <div className='flex flex-col gap-1 text-[#fff]'>
                                                <FaShop />
                                                <RxDotsVertical />
                                            </div>
                                        </div>
                                    </div>

                                    <div className=' w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-end'>
                                        {/* <div className='bg-[#fff] w-[100%] p-2   '>
                                    <img src={notemplate} alt="" className='object-cover' />
                                </div> */}
                                        <div className='w-[100%] flex justify-between items-center gap-1'>
                                            <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
                                                <div className='flex items-center gap-2'>
                                                    <CiFaceSmile />
                                                    <span className='text-[#575656] text-[12px]'>Enter your message</span>
                                                </div>
                                                <div className='flex items-center gap-2 text-[#575656]'>
                                                    <FaPaperclip />
                                                    <FaCamera />
                                                </div>
                                            </div>
                                            <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
                                                <FaMicrophone />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex w-[100%] justify-center  mt-1 mb-2 gap-2' >
                                <Link to='/WAMessage/WATemplate/Index'>
                                    <button
                                        className='p-2 bg-[#e92b2b] rounded-md text-[16px] flex items-center gap-1 font-semibold text-[#fff]'>Discard <FaRecycle /></button>
                                </Link>

                                <button
                                    onClick={handletemplate}
                                    className='p-2 bg-[#00816a] rounded-md text-[16px] flex items-center gap-1 font-semibold text-[#fff] '> Next <MdSkipNext />

                                </button>

                            </div>
                        </div>

                    </div>
                </div >
            </div>
        </>
    )
}

export default SetupYourTemplate
